// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getAnalytics, isSupported as analyticsSupported } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDHwNxJ9v2lHVkV3Kw54EtkgwxEou9eUH4",
    authDomain: "agri-vision-gabon-f32c3.firebaseapp.com",
    projectId: "agri-vision-gabon-f32c3",
    storageBucket: "agri-vision-gabon-f32c3.firebasestorage.app",
    messagingSenderId: "812950880210",
    appId: "1:812950880210:web:3cb758d81a572eccff520b",
    measurementId: "G-FVXLS961B4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics conditionally
let analytics = null;
if (typeof window !== 'undefined') {
  analyticsSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  }).catch((error) => {
    console.log('Analytics not supported:', error);
  });
}

// Export Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

// Initialize messaging conditionally
export let messaging = null;
if (typeof window !== 'undefined') {
  isSupported().then((supported) => {
    if (supported) {
      messaging = getMessaging(app);
      console.log('Firebase Messaging is supported');
    } else {
      console.log('Firebase Messaging is not supported in this browser');
    }
  }).catch((error) => {
    console.error('Error checking messaging support:', error);
  });
}

// Fonction pour demander la permission et obtenir le token FCM
export const requestNotificationPermission = async () => {
  try {
    // Vérifier si messaging est disponible
    if (!messaging) {
      console.log('Messaging n\'est pas supporté dans ce navigateur');
      return null;
    }

    // Vérifier si le navigateur prend en charge les notifications
    if (!('Notification' in window)) {
      console.log('Ce navigateur ne prend pas en charge les notifications');
      return null;
    }

    // Vérifier si on est en HTTPS (requis pour les notifications)
    if (typeof window !== 'undefined' && 
        window.location.protocol !== 'https:' && 
        window.location.hostname !== 'localhost') {
      console.log('HTTPS requis pour les notifications push');
      return null;
    }

    // Demander la permission
    const permission = await Notification.requestPermission();
    
    if (permission !== 'granted') {
      console.log('Permission de notification non accordée');
      return null;
    }

    // Attendre que messaging soit initialisé
    await new Promise((resolve) => {
      const checkMessaging = () => {
        if (messaging) {
          resolve();
        } else {
          setTimeout(checkMessaging, 100);
        }
      };
      checkMessaging();
    });

    // Obtenir le token FCM
    const currentToken = await getToken(messaging, {
      vapidKey: 'BLBz-RVxwQFLlZgO1Jh8TJGOvVWj0QFwF9pvXJYBjjHJpH-KyFwzV-WxCHOkjEJ9Lh9_RJVSHqPK9KS_TzcoEZo'
    });

    if (currentToken) {
      console.log('Token FCM obtenu:', currentToken);
      return currentToken;
    } else {
      console.log('Impossible d\'obtenir le token');
      return null;
    }
  } catch (error) {
    console.error('Erreur lors de la demande de permission:', error);
    return null;
  }
};

// Fonction pour écouter les messages entrants
export const onMessageListener = () => {
  return new Promise((resolve, reject) => {
    if (!messaging) {
      reject(new Error('Messaging not supported'));
      return;
    }
    
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
};

export { analytics };
export default app;